<template>
  <div class="flex items-center">
    <div class="flex w-full items-center bg-white rounded shadow-md flex-wrap">
      <input class="relative px-6 py-3 flex-grow rounded focus:shadow-outline" autocomplete="off" type="text" name="search" :placeholder="text" id="searchInput" :value="modelValue" @input="$emit('update:modelValue', $event.target.value)" />
      <div v-if="showFilter" class="py-3 px-6 bg-white rounded">
        <slot />
      </div>
      <div :class="['bg-white relative', showFilter ? 'pr-6' : '']" class="hidden sm:flex">
        <loading-button v-if="showReset"  text="Reset" icon-name="arrow-path" icon-mini :loading="loading" @click.prevent="$emit('reset')" small inverted/>
      </div>
    </div>
  </div>
</template>

<script>
import Dropdown from '@/Shared/Dropdown'
import LoadingButton from '@/Shared/LoadingButton'

export default {
  components: {
    LoadingButton,
  },
  props: {
    showReset: {
      type: Boolean,
      default: false
    },
    text: {
      type: String,
      default: 'Suche...'
    },
    modelValue: String,
    showFilter: Boolean,
    loading: Boolean,
    maxWidth: {
      type: Number,
      default: 300,
    },
  },
  emits: ['update:modelValue', 'reset'],
}
</script>
